<script>
export default {
  data () {
    return {
      selection: null,
      arc: null,
      arc2: null,
      current_arc: 0,
      current_arc2: 0,
      current_font_size: this.font_size,
      current_value: 0,
      current_duration: 0,
      current_width: 0,
      current_height: 0,
      margin_top: 0,
      margin_right: 0,
      margin_bottom: 0,
      margin_left: 0,
      diameter: 0,
    }
  },

  props: {
    id: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
    min_value: {
      type: Number,
      default: 0
    },
    max_value: {
      type: Number,
      default: 1
    },
    percentage: {
      default: true
    },
    width: {
      type: Number,
      default: 300
    },
    height: {
      type: Number,
      default: 300
    },
    label: {
      type: String,
      default: 'Progress'
    },
    font_size: {
      type: Number,
      default: 10
    }
  },

  mounted () {
    this.arc = d3.svg.arc().startAngle(0 * (Math.PI/180))
    this.arc2 = d3.svg.arc().startAngle(0 * (Math.PI/180)).endAngle(0)

    this.draw()
  },

  methods: {
    /*
     * Check the measurements
     */
    measure: function () {
      this.height = this.width
      this.margin_bottom = this.width * 0.2
      this.diameter = this.width * 0.5
      this.current_width = this.width - this.margin_bottom
      this.current_height = this.current_width
      this.margin_left = this.margin_bottom * 0.5

      this.current_font_size = this.current_width * .2

      this.arc.outerRadius(this.current_width * 0.5)
      this.arc.innerRadius(this.current_width * 0.5 * 0.85)

      this.arc2.outerRadius(this.current_width * 0.5 * 0.85)
      this.arc2.innerRadius(this.current_width * 0.5 * 0.85 - (this.current_width * 0.5 * 0.15))
    },

    /*
     * Render the svg
     */
    draw: function () {
      this.measure()

      let selection = d3.select('#radial-progress' + this.id)

      // Select the svg element, if it exists.
      let svg = selection.selectAll("svg").data([this.id])

      let radial_progress = svg.enter()
          .append("svg")
          .attr("class","radial-progress-svg")
          .append("g")

      svg.attr("width", this.width)
         .attr("height", this.height)

      let component = radial_progress.append("g")
          .attr("class", "component")

      this.arc.endAngle(360 * (Math.PI/180))

      component.append("rect")
          .attr("class", "background")
          .attr("width", this.current_width)
          .attr("height", this.current_height)

      component.append("path")
          .attr("transform", "translate(" + this.current_width*0.5 + "," + this.current_width*0.5 + ")")
          .attr("d", this.arc)

      component.append("text")
          .attr("class", "label")
          .attr("transform", "translate(" + this.current_width*0.5 + "," + (this.current_width + this.current_font_size) + ")")
          .text(this.label)
          .style("font-size",this.current_font_size*0.8+"px")

      let g = svg.select("g")
          .attr("transform", "translate(" + this.margin_left + "," + this.margin_top + ")")

      this.arc.endAngle(this.current_arc)
      radial_progress.append("g").attr("class", "arcs")

      let path = svg.select(".arcs")
          .selectAll(".arc")
          .data([this.id])
      path.enter().append("path")
          .attr("class","arc")
          .attr("transform", "translate(" + this.current_width*0.5 + "," + this.current_width*0.5 + ")")
          .attr("d", this.arc)

      //Another path in case we exceed 100%
      let path2 = svg.select(".arcs")
          .selectAll(".arc2")
          .data([this.id])
      path2.enter().append("path")
          .attr("class","arc2")
          .attr("transform", "translate(" + this.current_width*0.5 + "," + this.current_width*0.5 + ")")
          .attr("d", this.arc2)

      radial_progress.append("g").attr("class", "labels")

      let label = svg.select(".labels")
          .selectAll(".label")
          .data([this.id])
      label.enter()
          .append("text")
          .attr("class","label")
          .attr("y",this.current_width*0.5+this.current_font_size*0.3)
          .attr("x",this.current_width*0.5)
          .attr("cursor","pointer")
          .attr("width",this.current_width)
          .text(function (d) {
            if(this.percentage) {
              return Math.round((this.value-this.min_value)/(this.max_value-this.min_value)*100) + "%"
            }
            return this.value + '/' + this.max_value
          })
          .style("font-size",this.current_font_size+"px")

      path.exit()
          .transition()
          .duration(500)
          .attr("x",1000)
          .remove()

      this.layout(svg, path, path2, label)
    },

    layout: function(svg, path, path2, label) {
      let ratio=(this.value-this.min_value)/(this.max_value-this.min_value)
      let endAngle=(Math.min(360*ratio,360))*Math.PI/180

      path.datum(endAngle)
      path.transition().duration(this.current_duration)
          .attrTween("d", this.arcTween)

      if (ratio > 1) {
          path2.datum(Math.min(360*(ratio-1),360) * Math.PI/180)
          path2.transition().delay(this.current_duration).duration(this.current_duration)
               .attrTween("d", this.arcTween2)
      }

      label.datum(Math.round(ratio*100))
      label.transition().duration(this.current_duration)
          .tween("text", this.labelTween)

      this.current_duration = this.duration
    },

    labelTween: function(a) {
        let i = d3.interpolate(this.current_value, a)
        this.current_value = i(0)
        let parent = this

        return function(t) {
            parent.current_value = i(t)
            if(parent.percentage) {
              this.textContent = Math.round(i(t)) + "%"
            } else {
              this.textContent = parent.value + '/' + parent.max_value
            }
        }
    },

    arcTween: function(a) {
        let i = d3.interpolate(this.current_arc, a)
        let parent = this

        return function(t) {
            parent.current_arc=i(t)
            return parent.arc.endAngle(i(t))()
        }
    },

    arcTween2: function(a) {
        let i = d3.interpolate(this.current_arc2, a)
        let parent = this

        return function(t) {
            return parent.arc2.endAngle(i(t))()
        }
    }
  },
}
</script>

<template>
  <div class="radial-progress"
    :id="'radial-progress' + id"
  >
  </div>
</template>
